import * as React from 'react'
import * as ReactDOM from 'react-dom'
import App from './App'
import { Provider, IReactComponent } from 'mobx-react'
import { Router, Route } from 'react-router-dom'

import './index.module.css'
import { createStore } from './store'

import createBrowserHistory from 'history/createBrowserHistory'
import { syncHistoryWithStore } from 'mobx-react-router'

// import registerServiceWorker from './registerServiceWorker';
function renderApp (component: IReactComponent) {
  const store = createStore()

  // @ts-ignore
  window.store = store

  const browserHistory = createBrowserHistory()
  const history = syncHistoryWithStore(browserHistory, store.storeRouter)

  // setTimeout(() => {
  //   // redirect if ie
  //   if (isIE()) {
  //     console.log('Found IE')
  //     if (store.storeRouter.location.pathname !== '/browser-not-supported') {
  //       store.storeRouter.push('/browser-not-supported')
  //     }
  //   }
  // }, 50)

  ReactDOM.render(
    <Provider {...store} >
      <Router history={history}>
       <Route component={App} props/>
      </Router>
    </Provider>,
    document.getElementById('duerrenmatt-map') as HTMLElement)

}

function startApp () {
  // const translations = await import(`./translations/${window.locale}_flat`);
  renderApp(App)

}

// try tp start
let interVal = setInterval(() => {
  if (document.getElementById('duerrenmatt-map')) {
    clearInterval(interVal)
    startApp()
  }
}, 100)

// registerServiceWorker();
